import bemCssModules from 'bem-css-modules';
import type { VFC } from 'react';

import { Breadcrumb } from './Breadcrumb';
import BreadcrumbsModuleCss from './Breadcrumbs.module.css';
import { HomeBreadcrumb } from './HomeBreadcrumb';
import type { SiteMapItem } from '~/models/siteMap';

const block = bemCssModules(BreadcrumbsModuleCss);

interface BreadcrumbsWithDataProps {
  siteMapItemCollection: SiteMapItem[];
}

export const BreadcrumbsWithData: VFC<BreadcrumbsWithDataProps> = ({ siteMapItemCollection }) => (
  <div
    key={window.location.pathname}
    className={block({ 'is-category-page': true })}
  >
    <HomeBreadcrumb />
    {siteMapItemCollection.map((item) => (
      <Breadcrumb
        key={item.Path}
        {...item}
      />
    ))}
  </div>
);
